import { render, staticRenderFns } from "./moblie.vue?vue&type=template&id=6771ef73&scoped=true"
import script from "./moblie.vue?vue&type=script&lang=js"
export * from "./moblie.vue?vue&type=script&lang=js"
import style0 from "./moblie.vue?vue&type=style&index=0&id=6771ef73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6771ef73",
  null
  
)

export default component.exports